module.exports = __webpack_public_path__ + "img/facturas.d123fdf1.svg";